import { render, staticRenderFns } from "./CurrenciesPage.vue?vue&type=template&id=e5a87c08"
import script from "./CurrenciesPage.vue?vue&type=script&lang=js"
export * from "./CurrenciesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports